import React, { useEffect,  useRef,  useState } from "react";
import {
  ACTIONARROW_ICON,
  EDIT_ICON,
  RIGHTARROW_ICON,
} from "../../../utills/image-constant";
import AdminDataTable from "../../components/common/AdminDataTable";
import TableHeading from "../../components/common/TableHeading";
import SearchAndAddItem from "../../components/common/TableData";
import { ROUTES } from "../../routes/url-constant";
import {  useNavigate } from "react-router-dom";
import { activeInactiveEmployee, getAllCompanies, getAllEmployee } from "../../../services/api-services";
import { toastEmitter } from "../../../utills/utilities";
import { API_RESPONSE } from "../../../utills/app-constant";
import { useSelector } from "react-redux";
import AccessPermissionpage from "./AccessPermissionpage";
import EmployeeBulkUpload from "./EmployeeBulkUpload";
import Modal from "../../components/common/Model";

const CompanyEmployeeManagement = () => {
  const [pending, setPending] = useState(false);
  const [rowData, setRowData] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [sortColumn, setSortColumn] = useState("id");
  const [sortDirection, setSortDirection] = useState("desc");
  const [permissionAccess, setPermissionAccess] = useState();
  const [companyList, setCompanyList] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState(localStorage.getItem("ComapnyMengCompanyId") || "");
  const [totalElement, settotalElement] = useState();
  const { value } = useSelector((state) => state?.adminRole);

  const [isModalOpen, setIsModalOpen] = useState(false);
   const modalRef = useRef();
  const navigate = useNavigate();
  let viewEmMegComapnyId = localStorage.getItem("ComapnyMengCompanyId");

  useEffect(() => {
    const RoleAccessFilterData =
      value && value.filter((v) => v.moduleName === "Customer Management");
    setPermissionAccess(RoleAccessFilterData?.[0]);
  }, [value]);

  // Build the payload inline when calling the API
  const getallEmployee = async () => {
    setPending(true);
    const currentPayload = {
      pageIndex: page,
      pageSize: pageSize,
      searchText: searchText,
      direction: sortDirection,
      filterByFieldName: sortColumn,
      companyId: viewEmMegComapnyId ? viewEmMegComapnyId : selectedCompanyId || "",
      employeeList: []
    };

    try {
      const response = await getAllEmployee(currentPayload);
      if (response?.data?.responseCode === 404) {
        setRowData([]);
      } else if (response?.data?.responseCode === 200) {
        const res = response?.data?.responseBody?.employeeResponsePayloadList;
        setRowData(res);
        settotalElement(response?.data?.responseBody?.totalElement);
      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    } finally {
      setPending(false);
    }
  };

  useEffect(() => {
    getallEmployee();
  }, [page, pageSize, searchText, sortColumn, sortDirection, selectedCompanyId, viewEmMegComapnyId]);

  // Fetch the list of companies
  const getallCompany = async () => {
    setPending(true);
    try {
      const response = await getAllCompanies();
      if (response?.data?.responseCode === 404) {
        setCompanyList([]);
      } else if (response?.data?.responseCode === 200) {
        const companyOptions = response?.data?.responseBody.map((data) => ({
          value: data?.id,
          label: data?.companyName,
          Status: data?.status,
        }));
        setCompanyList(companyOptions);
      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    } finally {
      setPending(false);
    }
  };

  useEffect(() => {
    getallCompany();
  }, []);

  const handleModelSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  const handleSelect = (event) => {
    const selectedValue = event.target.value;
    setSelectedCompanyId(selectedValue);
    if (selectedValue === "") {
      localStorage.removeItem("ComapnyMengCompanyId");
    } else {
      localStorage.setItem("ComapnyMengCompanyId", selectedValue);
    }
  };

  const addButtonClick = () => {
    navigate(ROUTES.ADDCOMPANYEMLOYEE);
  };

  const tableCustomStyles = {
    headRow: {
      style: {
        color: "#1B2128",
        fontSize: "14px",
      },
    },
    rows: {
      style: {
        color: "#1B2128",
        fontSize: "14px",
      },
    },
  };

  const tblColumns = [
    {
      code: "Action",
      name: "Action",
      sortable: false,
      cell: (row) => (
        <div>
          <button className="border-0 bg-white">
            <img
              src={EDIT_ICON}
              alt="Edit"
              className="editicon"
              onClick={() =>
                navigate(ROUTES?.ADDCOMPANYEMLOYEE, {
                  state: { pageType: "Edit", Data: row },
                })
              }
            />
            <span>
              <button
                className="border-0 bg-white"
                onClick={() =>
                  navigate(ROUTES.ADDCOMPANYEMLOYEE, { state: { pageType: "view", Data: row } })
                }
              >
                <img src={ACTIONARROW_ICON} alt="View" className="editicon ms-2" />
              </button>
            </span>
          </button>
        </div>
      ),
    },
    {
      code: "employeeName",
      name: "Employee Name",
      width: "180px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.employeeName}</div>
      ),
    },
    {
      code: "companyName",
      name: "Company Name",
      width: "220px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.companyName}</div>
      ),
    },
    {
      code: "email",
      name: "Email",
      width: "250px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.email}</div>
      ),
    },
    // {
    //   code: "modelName",
    //   name: "Maturity Model",
    //   width: "220px",
    //   sortable: true,
    //   selector: (row) => (
    //     <div className="table-cell-content">{row?.modelName}</div>
    //   ),
    // },
    {
      code: "department",
      name: "Department",
      width: "250px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.department}</div>
      ),
    },
    {
      code: "hierarchy",
      name: "Hierarchy",
      width: "150px",
      sortable: true,
      selector: (row) => (
        <div className="table-cell-content">{row?.hierarchy}</div>
      ),
    },
    {
      code: "status",
      name: "Status",
      width: "130px",
      omit: false,
      sortable: true,
      cell: (row) => (
        <div className="form-switch-btn">
          <label className="switch">
            <input
              disabled={permissionAccess?.moduleAction === 0}
              type="checkbox"
              id="togBtn"
              checked={row?.status === 1}
              onChange={() => handleStatusChange(row)}
            />
            <div className="slider round">
              {row?.status === 1 ? (
                <span className="on">Active</span>
              ) : (
                <span className="off">Inactive</span>
              )}
            </div>
          </label>
        </div>
      ),
    },

  ];

  const handleStatusChange = async (row) => {
    const newStatus = row?.status === 1 ? 0 : 1; // Toggle status
    const updatedRowData = rowData.map((item) =>
      item.id === row.id ? { ...item, status: newStatus } : item
    );
    setRowData(updatedRowData);

    try {
      const response = await activeInactiveEmployee(row.id, newStatus);
      if (response?.data?.responseCode === 200) {
        toastEmitter("success", response?.data?.message);
      } else {
        // Revert status if API call fails
        const revertRowData = rowData.map((item) =>
          item.id === row.id ? { ...item, status: row?.status } : item
        );
        setRowData(revertRowData);
      }
    } catch (error) {
      // Revert status on error
      const revertRowData = rowData.map((item) =>
        item.id === row.id ? { ...item, status: row?.status } : item
      );
      setRowData(revertRowData);
    }
  };

  const handleClearFilter = () => {
    setSelectedCompanyId("");
    localStorage.removeItem("ComapnyMengCompanyId");
  };

  return (
    <>
      {permissionAccess?.addAction === 0 &&
        permissionAccess?.updateAction === 0 &&
        permissionAccess?.viewAction === 0 ? (
        <AccessPermissionpage />
      ) : (
        <div className="modal_datatable">
          <TableHeading
            firstData="Customer Management"
            icon={RIGHTARROW_ICON}
            secondData="Employee Management"
          />
          <div className="container-fluid">
            <div className="caspera_admin_datatable mb-3">
              <SearchAndAddItem
                searchValue={searchText}
                onSearchChange={handleModelSearchChange}
                addButtonClick={addButtonClick}
                data="Employee"
                permissionAccessbtn={permissionAccess?.addAction}
                labelName="Select Company"
                lableclassName="addInput-label"
                name="companyId"
                options={companyList}
                className="form-control addInputText-lable"
                handleSelect={handleSelect}
                value={viewEmMegComapnyId ? viewEmMegComapnyId : selectedCompanyId}
                showDropdown={true}
                clearbtn={true}
                showuploadbtn={true}
                  setIsModalOpen={() => {
                  setIsModalOpen(true);
                  modalRef.current.click(); // trigger bootstrap modal
                }}
                handleClear={handleClearFilter}
              />
              <AdminDataTable
                _tblColumns={tblColumns}
                _rowData={rowData}
                tableCustomStyles={tableCustomStyles}
                _totalRows={totalElement}
                pending={pending}
                setPending={setPending}
                pageSize={pageSize}
                
                setPageSize={setPageSize}
                setPage={setPage}
                setSortColumn={setSortColumn}
                setSortDirection={setSortDirection}
              />
            </div>
          </div>
        </div>
        
      )}
       <Modal
            modalClick={modalRef}          
            modalClose={() => setIsModalOpen(false)}
            title="Employee Bulk Upload"
            className="modal-lg"
            buttonLable=""                 
          >
            <EmployeeBulkUpload 
            onUploadSuccess={() => {
      getallEmployee(); // 🔁 Refresh employee list after upload
      setIsModalOpen(false); // close modal
    }}
            />
          </Modal>
    </>
  );
};

export default CompanyEmployeeManagement;
